<div class="overview">
  <div class="overview__main">
    <section class="card" aria-labelledby="aboutTitle">
      <header class="card__head"><h2 class="card__title" id="aboutTitle">About me</h2></header>
      <div class="card__body overview__about">
        @if (aboutHtml) {
          <ngf-rich-text-viewer [content]="aboutHtml"></ngf-rich-text-viewer>
        } @else if (aboutMarkdown) {
          <div [innerHTML]="aboutMarkdown"></div>
        } @else {
          <p class="overview__muted">{{ user.name }} hasn't shared anything about themselves yet.</p>
        }
      </div>
    </section>

    @if (interval(); as current) {
      <section class="card" aria-labelledby="activityTitle">
        <header class="card__head">
          <h2 class="card__title" id="activityTitle">Community activity</h2>
          @if (intervals.length > 1) {
            <label class="sr-only" for="activityRange">Time range</label>
            <select class="overview__select" id="activityRange" [value]="current.label" (change)="selectInterval($any($event.target).value)">
              @for (option of intervals; track option.label) {
                <option [value]="option.label">{{ option.title }}</option>
              }
            </select>
          } @else {
            <span class="overview__muted">{{ current.title }}</span>
          }
        </header>
        <div class="card__body">
          <div class="overview__totals">
            @for (s of series; track s.key) {
              <div class="overview__total">
                <span class="overview__legend overview__legend--{{ s.tone }}">{{ s.label }}</span>
                <b>{{ current.totals[s.key] | number }}</b>
              </div>
            }
          </div>
          <div class="chart" role="img" [attr.aria-label]="chartLabel(current)">
            <div class="chart__y" aria-hidden="true">
              @for (tick of current.ticks; track $index) {
                <span>{{ tick }}</span>
              }
            </div>
            <div class="chart__plot" aria-hidden="true">
              @for (bar of current.bars; track $index) {
                <div class="chart__bar">
                  @for (segment of bar.segments; track segment.tone) {
                    <i class="chart__segment overview__legend--{{ segment.tone }}" [style.height.%]="segment.percent"></i>
                  }
                </div>
              }
            </div>
            <div class="chart__x" aria-hidden="true">
              @for (bar of current.bars; track $index) {
                <span>{{ bar.label }}</span>
              }
            </div>
          </div>
        </div>
      </section>
    }
  </div>

  <aside class="overview__side">
    @if (platformBadges.length) {
      <section class="card" aria-labelledby="testingBadgesTitle">
        <header class="card__head"><h2 class="card__title" id="testingBadgesTitle">Testing type badges</h2></header>
        <ul class="card__body overview__badges">
          @for (badge of platformBadges; track badge.label) {
            <li>
              <img [src]="'/utest-static/assets/images/badges/testerBadge-' + badge.level + '.svg'" alt="" width="36" height="36" />
              <b>{{ badge.label }}</b>
              <span class="overview__level overview__level--{{ badge.level }}">{{ badge.level | capitalize }}</span>
            </li>
          }
        </ul>
      </section>
    }

    @if (hasPlatformStats) {
      <section class="card" aria-labelledby="onUtestTitle">
        <header class="card__head"><h2 class="card__title" id="onUtestTitle">On uTest</h2></header>
        <dl class="card__body overview__dl">
          @if (stats.joined_at) {
            <dt>Joined</dt>
            <dd>{{ stats.joined_at | date: 'mediumDate' }}</dd>
          }
          @if (stats.last_login_at) {
            <dt>Last login</dt>
            <dd>{{ stats.last_login_at | relativeDate }}</dd>
          }
          @if (stats.last_commented_at) {
            <dt>Last comment</dt>
            <dd>{{ stats.last_commented_at | relativeDate }}</dd>
          }
        </dl>
      </section>
    }

    @if (communityBadges.length) {
      <section class="card" aria-labelledby="communityBadgesTitle">
        <header class="card__head">
          <h2 class="card__title" id="communityBadgesTitle">Community badges</h2>
          <span class="overview__count">{{ communityBadges.length }}</span>
        </header>
        <div class="card__body">
          <ul class="overview__cbadges">
            @for (badge of communityBadges; track $index) {
              @if (showAllBadges() || $index < visibleBadges) {
                <li>
                  <img [src]="'/utest-static/assets/images/badges/' + badge.icon" alt="" width="44" height="44" />
                  <b>{{ badge.name }}</b>
                  <span>+{{ badge.points }} pts</span>
                </li>
              }
            }
          </ul>
          @if (communityBadges.length > visibleBadges) {
            <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm overview__all" (click)="showAllBadges.set(!showAllBadges())">
              {{ showAllBadges() ? 'Show fewer' : 'View all ' + communityBadges.length }}
            </button>
          }
        </div>
      </section>
    }
  </aside>
</div>
